<style scoped>
  @import "../../../../assets/css/table-list.css";
  .form-title{ line-height: 40px;text-indent: 10px;background-color: #f3f3f3;margin-bottom: 10px; }
  .margin-right10{ margin-right: 10px; }
  .detail-group section{ margin-bottom: 14px; }
  .detail-group section label{ margin-right: 15px; }
  .detail-group section label,.detail-group section span{ display: inline-block; }
  .tx-user{ width: 50px;max-height: 100px; }
</style>
<style>
  .ivu-form-item-content{ line-height: 33px; }
</style>
<template>
  <div>
    <!--选择费用列表-->
    <div class="margin-bottom-10 header-group">
      <Input v-model="searchForm.payID" placeholder="请输入费用编号" style="width: 200px" />
      <Button type="primary" @click="search()">查询</Button>
    </div>
    <div>
      <Table highlight-row border :columns="d_columns" :data="d_data"
             @on-current-change="get_select_data"></Table>
    </div>
    <div class="margin-top-20">
      <Page :total="d_total" show-sizer show-total @on-change="flip" @on-page-size-change="change_size" class="pull-right"></Page>
      <div class="clear-both"></div>
    </div>
  </div>
</template>
<script>
  import apiPay from '@/api/pay.js';
  let moment = require('moment');
  export default {
    name:'cost_gather',
    props:{
      ContractID:String
    },
    watch:{
      ContractID(){
        this.pull_data();
      }
    },
    data() {
      return {
        params: {},
        d_total: 0,
        d_page: 1,
        d_page_size: 10,
        d_columns: [
          {
            title: '费用编号',
            key: 'ID',
          },
          {
            title: '所属合同',
            key: 'ContractName',
          },
          {
            title: '小项',
            key: 'XiaoXiang',
          },
          {
            title: '金额',
            key: 'Money',
            render: (h, params) => {
              return h('span',params.row.Money+' 元')
            }

          },
          {
            title: '余额',
            key: 'Yue',
            render: (h, params) => {
              return h('span',params.row.Yue+' 元')
            }

          },
          {
            title: '是否已开票',
            key: 'IsInvoice',
          },
          {
            title: '负责人',
            key: 'Agent',
          },
        ],
        d_data: [],
        searchForm:{
          payID:'',
        }
      };
    },
    methods: {
      to_date(date){
        return moment(date).format('YYYY-MM-DD');
      },
      search() {
        this.params.PageIndex = 1;
        this.pull_data();
      },
      flip(page) { //翻页条件，每页多少条，多少页
        this.params.PageIndex = page;
        this.params.PageSize = this.d_page_size;
        this.pull_data();
      },
      change_size(size) { //改变limit 每页显示多少条
        this.params.PageSize = size;
        this.pull_data();
      },
      pull_data() {
        let _this = this;
        this.params.CondList=[
          {
            Key: "p.ID",//费用编号
            Operator: "like",
            Value: this.searchForm.payID,
          },
          {
            Key: "p.ContractID",//合同编号
            Operator: "=",
            Value: this.ContractID,
          },
        ]
        apiPay.getList.post(this.params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let requestResult = _data.data.Data;
            let rowsList = requestResult.RowsList;
            for (let i = 0; i < rowsList.length; i++) {
              rowsList[i].MoneyDate = _this.to_date(rowsList[i].MoneyDate);
              rowsList[i].PaperDate = _this.to_date(rowsList[i].PaperDate);
            }
            _this.d_total = requestResult.Total;
            _this.d_data = rowsList.filter(item => {
              return item.Yue > 0 && item.ShouTuiType==='收款' //退款和无不能缴费
            })
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      get_select_data(row){ //只能单选
         this.$emit('selectPay',row);
      },
    },
    created() {
      this.params = JSON.parse(JSON.stringify(apiPay.getList.data));
      this.pull_data();
    },
    mounted(){
      this.params.CondList[0].Key = 'p.ID';
      this.params.CondList[0].Operator = 'like';
    }
  }
</script>





















